/**
 * 감사글·배송지처럼 localStorage에 보존되는 주문 입력값의 "명의" 판정.
 *
 * 보존값은 브라우저 단위라, 전화주문(대리주문)으로 여러 상주를 연달아 응대하면
 * 앞 상주(심하면 같은 상가의 다른 가족)의 감사글·주소가 다음 주문서에 그대로 뜬다.
 * 남의 장례 문구·주소가 미리 채워져 있는 건 그 자체로 응대 사고이므로,
 * 보존값에 "어느 부고(bugo)의 입력인지" 도장을 찍어두고 **정확히 일치할 때만**
 * 자동으로 채운다. 도장이 없는 값(도장 도입 전 보존분)은 채우지 않는다.
 *
 * 같은 부고 안에서는 그대로 이어 쓰므로, 상품을 바꿔 담거나 결제가 실패해도
 * 재입력 부담은 늘지 않는다.
 */
export const isOwnedByBugo = (
  ownerBugoId: string | undefined,
  bugoId: string | null | undefined,
): boolean => Boolean(ownerBugoId && bugoId && ownerBugoId === bugoId);
